import { Ability, AbilityPath, Character, Event } from 'game/core'
import { Effect, EffectPath } from 'game/core/effect'
import { Nullable } from 'game/util/maybe'
import { Memoize } from 'game/util/memoize'

export class AbilityCanceled extends Event<{
    ability: AbilityPath,
    effect: EffectPath
}> {
    static KEY = 'AbilityCanceled' as const

    @Memoize()
    get character(): Nullable<Character> {
        return Character.byPath(this.battle, this.state.ability)
    }

    @Memoize()
    get ability(): Nullable<Ability> {
        return Ability.byPath(this.battle, this.state.ability)
    }

    @Memoize()
    get effect(): Nullable<Effect> {
        return Effect.byPath(this.battle, this.state.effect)
    }
}
